import React, { Component } from "react";
import {
  Container,
  Segment,
  Header
} from "semantic-ui-react";

import AppContainer from "./AppContainer";
import BookInform from "./BookInform";
import BookNewForm from "./BookNewForm";
import BookPicWarning from "./BookPicWarning";
import BookUpload from "./BookUploadPic";
import BookReview from "./BookReview";
import BookSubmit from "./BookSubmit";
import PageModel from "./PageModel";

import * as httpRequests from "./httpRequests";

const BookStep = {
  inform: 0,
  initialForm: 1,
  pageWarning: 2,
  uploadPic: 3,
  review: 4,
  finished: 5
};

const style = {
  mainContainer: {
    marginTop: "3em",
    marginBottom: "3em",
    paddingTop: "3em",
    paddingBottom: "3em"
  }
};


class MakeBookLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: BookStep.inform,
      currentPic: 0,
      name: "",
      email: "",
      telephone: "",
      pictures: [new PageModel()],
      uploadProgress: {
        percent: 0,
        isFinished: false,
        errorMsg: ''
      }
    };

    this.updateCurrentPic = this.updateCurrentPic.bind(this);

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleTelChange = this.handleTelChange.bind(this);

    this.handleInformClick = this.handleInformClick.bind(this);
    this.handleInitFormClick = this.handleInitFormClick.bind(this);
    this.handlePageWarningClick = this.handlePageWarningClick.bind(this);

    this.handleRemove = this.handleRemove.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNextPic = this.handleNextPic.bind(this);
    this.handleFinish = this.handleFinish.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  updateCurrentPic(new_pic) {
    var new_pic_list = this.state.pictures.slice();
    new_pic_list[this.state.currentPic] = new_pic;
    this.setState({ pictures: new_pic_list});
  }

  // Init information
  handleNameChange(e) {
    this.setState({
      name: e.target.value
    });
  }

  handleEmailChange(e) {
    this.setState({
      email: e.target.value
    });
  }

  handleTelChange(e) {
    if (/^[0-9]*$/.test(e.target.value)) {
      this.setState({
        telephone: e.target.value
      });
    }
  }

  handleInformClick(e) {
    this.setState({ step: BookStep.initialForm });
  }

  handleInitFormClick() {
    this.setState({
      step: BookStep.pageWarning
    });
  }

  handlePageWarningClick(){
    this.setState({
      step: BookStep.uploadPic
    });
  }

  handleRemove() {
    var new_pics = this.state.pictures.slice();
    var pic_id = this.state.currentPic;
    new_pics.splice(pic_id, 1);

    if(pic_id > 0) {
      pic_id -= 1;
    }

    if(new_pics.length === 0){
      new_pics.push(new PageModel());
    }

    this.setState({
      pictures: new_pics,
      currentPic: pic_id
    });
  }

  handlePrev() {
    if(this.state.step === BookStep.uploadPic && this.state.currentPic > 0){
      this.setState({
        currentPic: this.state.currentPic - 1
      });
    }else if(this.state.step === BookStep.review ){
      this.setState({
        currentPic: this.state.pictures.length - 1,
        step: BookStep.uploadPic
      });
    }else{
      this.setState({ step: BookStep.initialForm });
    }
  }

  handleNextPic() {
    if(this.state.currentPic === this.state.pictures.length - 1){ // is last
      // new pics
      var new_pics = this.state.pictures.slice();
      new_pics.push(new PageModel());
      this.setState({
        pictures: new_pics,
        currentPic: this.state.currentPic + 1
      });
    }else{
      this.setState({
        currentPic: this.state.currentPic + 1
      });
    }
  }

  handleFinish() {
    this.setState({ step: BookStep.review });
  }

  handleSubmit() {
    var theBook = {
      name: this.state.name,
      email: this.state.email,
      telephone: this.state.telephone,
      pictures: this.state.pictures
    };

    httpRequests.postBook(theBook, (progressE) => {
      var newProgress = Object.create(this.state.uploadProgress);
      newProgress.percent = (progressE.loaded / progressE.total) * 100;
      this.setState({ uploadProgress: newProgress });
    })
    .then((response) => {
      console.log(response);
      var newProgress = Object.create(this.state.uploadProgress);
      newProgress.isFinished = true;
      this.setState({ uploadProgress: newProgress });
    })
    .catch((error) => {
      console.log(error);
      var newProgress = Object.create(this.state.uploadProgress);
      newProgress.errorMsg = error.message;
      this.setState({ uploadProgress: newProgress });
    });

    this.setState({ step: BookStep.finished });
  }

  render() {
    var content;
    switch (this.state.step) {
      case BookStep.inform:
        content = <BookInform onNext={this.handleInformClick} />;
        break;
      case BookStep.initialForm:
        content = (
          <BookNewForm
            name={this.state.name}
            email={this.state.email}
            telephone={this.state.telephone}
            onNext={this.handleInitFormClick}
            handleNameChange={this.handleNameChange}
            handleEmailChange={this.handleEmailChange}
            handleTelChange={this.handleTelChange}
          />
        );
        break;
      case BookStep.pageWarning:
        content = <BookPicWarning onNext={this.handlePageWarningClick} />;
        break;
      case BookStep.uploadPic:
        content = (
          <BookUpload
            picnum={this.state.currentPic + 1}
            isLast={this.state.currentPic === this.state.pictures.length - 1}
            formValue={this.state.pictures[this.state.currentPic]}
            onFormValueChange={this.updateCurrentPic}
            onRemove={this.handleRemove}
            onPrev={this.handlePrev}
            onNext={this.handleNextPic}
            onFinish={this.handleFinish}
          />
        );
        break;
      case BookStep.review:
        content = (
          <BookReview
            name={this.state.name}
            email={this.state.email}
            telephone={this.state.telephone}
            pictures={this.state.pictures}
            onBack={this.handlePrev}
            onNext={this.handleSubmit}
            />
        );
        break;
      case BookStep.finished:
        content = <BookSubmit uploadProgress={this.state.uploadProgress} />;
        break;
      default:
        content = <Header>Error!</Header>;
    }
    return (
      <AppContainer>
        <Container>
          <Segment style={style.mainContainer}>{content}</Segment>
        </Container>
      </AppContainer>
    );
  }
}

export default MakeBookLayout;
